import { RootState } from 'app/rootReducer';

export const getDocumentEntitySlice = (state: RootState) =>
  state.entities.documents;

export const getLinkAttachmentEntitySlice = (state: RootState) =>
  state.entities.link_attachments;
